import { createContext, Dispatch, SetStateAction } from 'react';

interface WelcomeViewWrapperContext {
  submitAgreementsButton: HTMLButtonElement | undefined;
  setSubmitAgreementsButton: Dispatch<SetStateAction<HTMLButtonElement | undefined>>;
  withBackgroundImage: boolean;
  setWithBackgroundImage: Dispatch<SetStateAction<boolean>>;
  withNoveltyFlag: boolean;
  setWithNoveltyFlag: Dispatch<SetStateAction<boolean>>;
  isP24MarketingAgreementsFormAvailable: boolean;
  setIsP24MarketingAgreementsFormAvailable: Dispatch<SetStateAction<boolean>>;
}

export const WelcomeViewWrapperContext = createContext<WelcomeViewWrapperContext | undefined>(
  undefined,
);
